// The $5 quick-setup PAYG ("Go Live") pricing shown in the app. Static on
// purpose — nothing is fetched. Keep it in step with what is actually charged:
//   • fee  → backend/src/utils/paygCurrency.js (NUMBER_FEE: $5 / CA$8)
//   • rate → the Stripe `free_metered_usage` price (USD amount / CAD option)
import { detectCheckoutCurrency } from "./checkoutCurrency";

// Free minutes included every month, in every currency.
export const FREE_MINUTES = 50;

export const PAYG_PRICING = {
  usd: { currency: "usd", code: "USD", symbol: "$", fee: 5, rate: 0.48 },
  cad: { currency: "cad", code: "CAD", symbol: "CA$", fee: 8, rate: 0.68 },
};

// The last pricing detectPaygPricing() resolved to; USD until the country is known.
let current = PAYG_PRICING.usd;

// Canada pays in CAD; every other country (or a failed lookup) in USD.
export const detectPaygPricing = () =>
  detectCheckoutCurrency().then((currency) => {
    current = PAYG_PRICING[currency] || PAYG_PRICING.usd;
    return current;
  });

// For code that cannot wait (the live agent's screen guide): the pricing known
// right now.
export const currentPaygPricing = () => current;

// "$5" / "CA$8"
export const feeText = (pricing) => `${pricing.symbol}${pricing.fee}`;
// "$0.48" / "CA$0.68"
export const rateText = (pricing) => `${pricing.symbol}${pricing.rate.toFixed(2)}`;
